module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 17.8\"><path d=\"M14 7L7 0 0 7l1.4 1.4L6 3.8v14h2v-14l4.6 4.6z\"/></svg>"


//////////////////
// WEBPACK FOOTER
// ./icons/arrowTop.svg
// module id = 6
// module chunks = 0